import { captureException } from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { Topology } from 'topojson-specification';

async function fetchGeography(signal: AbortSignal) {
	try {
		const response = await fetch(`/data/us/us.json`, { signal });
		const data = await response.json();
		return data as Topology;
	} catch (error) {
		console.error(error);
		captureException(error);
		throw error;
	}
}

export function useUSGeography() {
	const { data, isLoading, error } = useQuery({
		queryKey: ['us-geography'],
		queryFn: async ({ signal }) => fetchGeography(signal),
	});

	return {
		USGeography: data,
		USGeographyLoading: isLoading,
		USGeographyError: error,
	};
}
